// require( 'jszip' );
// require( 'pdfmake' );
// require( 'datatables.net-buttons/js/buttons.colVis.js' )();
// require( 'datatables.net-buttons/js/buttons.html5.js' )();
// require( 'datatables.net-buttons/js/buttons.print.js' )();
// require( 'datatables.net-colreorder-bs4' )();
// require( 'datatables.net-datetime' )();
// require( 'datatables.net-fixedcolumns-bs4' )();
// require( 'datatables.net-fixedheader-bs4' )();
// require( 'datatables.net-keytable-bs4' )();
// require( 'datatables.net-responsive-bs4' )();
// require( 'datatables.net-rowgroup-bs4' )();
// require( 'datatables.net-rowreorder-bs4' )();
// require( 'datatables.net-scroller-bs4' )();
// require( 'datatables.net-searchbuilder-bs4' )();
// require( 'datatables.net-searchpanes-bs4' )();
// require( 'datatables.net-select-bs4' )();
// require( 'datatables.net-staterestore-bs4' )();


// require('imports-loader?define=>false!datatables.net-bs4')(window, $);
// require('imports-loader?define=>false!datatables.net-select-bs4')(window, $);
// import 'datatables.net-bs4-dt/css/jquery.dataTables.css'
// import 'datatables.net-select-bs4-dt/css/select.dataTables.css'

import 'jszip';
import 'pdfmake';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'select2';
import 'cocoon-js';
import lt from 'select2/src/js/select2/i18n/lt.js'
import { Lithuanian } from "flatpickr/dist/l10n/lt.js"
import { initCharacterCounters } from '../shared/character_counter.js'

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form');
  const termsCheckbox = document.getElementById('terms_confirmation');
  
  if (form && termsCheckbox) {
    form.addEventListener('submit', function(event) {
      if (termsCheckbox && !termsCheckbox.checked) {
        event.preventDefault();
        alert('Prašome patvirtinti, kad susipažinote su Socialinio fondo tvarka.');
        return false;
      }
    });
  }
});

$(function() {
  initCharacterCounters();
  
  function autoResizeTextInputs() {
    $('input[type="text"].form-control').each(function() {
      if (this.scrollWidth > this.clientWidth) {
        $(this).css('width', (this.scrollWidth + 5) + 'px');
      }
    });
  }
  
  autoResizeTextInputs();
  
  $(document).on('input', 'input[type="text"].form-control', function() {
    if (this.scrollWidth > this.clientWidth) {
      $(this).css('width', (this.scrollWidth + 5) + 'px');
    }    
  });
  
  let tableOptions = {
    // 'B' - Buttons (csv, excel, pdf) changing
    // 'l' - Length changing
    // 'f' - Filtering input
    // 't' - The table!
    // 'i' - Information
    // 'p' - Pagination
    // 'r' - pRocessingg
    dom: 'rt<"pagination-container my-2"p>',
    ordering: true,
    order: [[0, 'desc']],
    pageLength: 10,
    pagingType: 'first_last_numbers',
    processing: true,
    serverSide: true,
    ajax: {
      url: '/selfservice/social_aid_requests',
      dataSrc: 'social_aid_requests',
      data: function(params) {
        delete params.columns;
        let formData = $('#social_aid_requests-search .form-control').serializeArray();
        params.q = {};
        formData.map(function(el, i){ 
          params['q'][el.name] = el.value;
        });

        params['length'] = $('#social_aid_requests-per-page').val();
      }
    },
    language: {
      lengthMenu: '_MENU_',
      processing: 'Kraunama',
      emptyTable: 'Nėra',
      paginate: {
        first:      'Pirmas',
        // previous:   "&lt;",
        // next:       "&gt;",
        last:       'Paskutinis'
    },
    },
    columns: [
      { 
        data: null,
        render: function(data, type, row){
          return `<a href="/selfservice/social_aid_requests/${row['id']}" class="link-avaka link">${row['project_name']}</a>`;
        }
      },
      { 
        data: null,
        render: function(data, type, row){
          return row['status']
        }
      },
      { 
        data: null,
        render: function(data, type, row) {

          let links = [];
          links.push(`<a href="/selfservice/social_aid_requests/${row['id']}" class="link-avaka yellow d-flex align-items-center justify-content-center mb-2">Peržiūrėti <i class='fa fa-angles-right ml-2'></i></a>`);
          // links.push(`<a href="/selfservice/social_aid_requests/${row['id']}/request_pdf" class="link-avaka blue d-flex align-items-center justify-content-center mb-2" target="_blank">Atsisiųsti paraišką <i class='fa fa-angles-right ml-2'></i></a>`)

          if (row['status'] ==  'Vyksta peržiūra') {
            links.push(`<a href="/selfservice/social_aid_requests/${row['id']}" data-method="delete" data-confirm="Ar tikrai?" class="link-avaka red d-flex align-items-center justify-content-center mb-2">Trinti <i class='fa fa-angles-right ml-2'></i></a>`);
          }
          
          if ((row['status'] ==  'Patvirtinta' && row['editable']) || row['status'] == 'Vyksta peržiūra') {
            links.push(`<a href="/selfservice/social_aid_requests/${row['id']}/edit" class="link-avaka green d-flex align-items-center justify-content-center mb-2">Redaguoti <i class='fa fa-angles-right ml-2'></i></a>`);
          }
          
            // links.push(`<a href="/selfservice/social_aid_requests/${row['id']}/generate_document" class="link-avaka blue d-flex align-items-center justify-content-center mb-2" target="_blank">Atsisiųsti sutartį <i class='fa fa-angles-right ml-2'></i></a>`);
            
          if (!row['has_report']  && (row['status'] == 'Patvirtinta' || row['status'] == 'Apmokėta' || row['status'] == 'Sutartis sugeneruota')) {
            links.push(`<a href="/selfservice/social_aid_request_reports/new?social_aid_request_id=${row['id']}" class="link-avaka green d-flex align-items-center justify-content-center">Sukurti ataskaitą <i class='fa fa-angles-right ml-2'></i></a>`);
          }

          return `
            <div class='menu-container'>
              <a href='javascript:void(0);' class='menu-toggle'>
                <i class='fa fa-ellipsis-h'></i>
              </a>
              <div class='menu-buttons' style='display: none;'>
                ${links.join('')}
              </div>
            </div>
          `;
        }
      },
    ]
  }

  var table = $('#social_aid_requests-table').DataTable(tableOptions);

  $(document).on('keyup', '#social_aid_requests-search .form-control', function(e){
    let url = window.location.pathname + '.xlsx' + '?' + $.param(table.ajax.params());
    $('#social_aid_requests-export').attr('href', url);
    table.draw();
  });

  $(document).on('change', '#social_aid_requests-search .form-control.custom-select', function(e){
    let url = window.location.pathname + '.xlsx' + '?' + $.param(table.ajax.params());
    $('#social_aid_requests-export').attr('href', url);
    table.draw();
  });
  
  $(document).on('change', '#social_aid_requests-per-page', function(e){
    let url = window.location.pathname + '.xlsx' + '?' + $.param(table.ajax.params());
    $('#social_aid_requests-export').attr('href', url);
    table.page.len(e.target.value).draw();
  });

  table.on('xhr', function (){
    $('#total_count').html(table.ajax.json().recordsTotal);
  });

  table.on('draw', function(){
    let url = window.location.pathname + '.xlsx' + '?' + $.param(table.ajax.params());
    $('#social_aid_requests-export').attr('href', url);
  });

  $(document).on('click', function(e) {
    // if the target of the click isn't the container nor a descendant of the container
    if (!$('.menu-container').is(e.target) && $('.menu-container').has(e.target).length === 0) {
      $('.menu-buttons').hide();
    }
  });

  $('#upload-file').on('click', function(e){
    $('.file-input').click(); 
  })

  $('.file-input').on('change', function(e){
    let files = e.target.files;
    $('#files-count').html(files.length + ' failai pasirinkti');
  })


  $('#social_aid_requests-table').on('click', '.menu-toggle', function(e) {
    e.stopPropagation();
    var menu = $(this).siblings('.menu-buttons');
    $('.menu-buttons').not(menu).hide();
    menu.toggle();
  });
});
